import { EnablePermanentJobM2M } from '~/constants/ff.posthog';
import { useFeatureFlag } from './useFeatureFlag';

export const useEnablePermanentJobMMFeature = () => {
  const isEnablePermanentJobMM = useFeatureFlag(EnablePermanentJobM2M);

  return { isEnablePermanentJobMM };
};
